import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const CreditCards = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M6 16H5C3.61929 16 2.5 14.8807 2.5 13.5V6.5C2.5 5.11929 3.61929 4 5 4H16C17.3807 4 18.5 5.11929 18.5 6.5V8" />
      <rect x="6.5" y="8" width="15" height="12" rx="2.5" />
      <path d="M6.5 12H21.5" />
      <path d="M12 16H10" />
    </svg>
  );
};
